import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  getFolderList,
  getMindfileItem,
  getMindfileItemLocations,
  getMindfileItems,
  getMindfileItemsDetails,
  setSelectedItems
} from '../../../../state/actions/getDataActions';
import {getFilterValues} from '../../../../state/actions/getFilterDataActions';
import {addFolder, moveItems, removeItems, updateItemViewCount} from '../../../../state/actions/updateDataActions';
import {
  bemeCell,
  createdCell,
  dateCell,
  descriptionCell,
  emotionCell,
  folderNameCell,
  formatItemDataType,
  iconCell,
  keywordsCell,
  locationCell,
  nameCell,
  peopleCell,
  selectCell,
  sizeCell,
  sourceCell,
  typeCell,
  updatedCell
} from './list-view/ItemCells';
import ItemsPage from './table/ItemsPage';
import BindViewOptions from "../../../util/data-table/BindViewOptions";

class JournalExplorer extends Component {

  filterDefinitions = [
    { label: "Status", key: "status", enabled: false, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
    { label: "Keywords", key: "keywords", enabled: true, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
    { label: "People", key: "people", enabled: true, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
    { label: "Folders", key: "folders", enabled: true, visible: true, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
    { label: "Emotions", key: "emotions", enabled: true, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Bemes", key: "bemes", enabled: true, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Item Types", key: "item_data_types", enabled: true, visible: false, options: (opts) => opts ? (opts.item_data_types || []).map((e) => ({value: e, name: formatItemDataType(e)})) : [] },
    { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => opts ? (opts.upload_types || []).map((e) => ({value: e, name: e.charAt(0).toUpperCase() + e.slice(1)})) : [] },
    { label: "Sources", key: "sources", enabled: false, visible: false, options: (opts) => opts ? (opts.sources || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Assessment", key: "survey_names", enabled: false, visible: false, options: (opts) => opts ? (opts.survey_names || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Assessment Status", key: "survey_complete", enabled: false, visible: false, options: (opts) => [{name:'Complete', value: 1}, {name: 'In Progress', value: 0}] },
  ];

  columns = [
    {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
    {key: 'type', header:{label: '', sort: null }, cell: typeCell, enabled: true },
    // {key: 'item_data_type', header: { label: '', sort: 'mindfile_items.item_data_type' }, cell: itemDataTypeCell, enabled: true },
    // {key: 'type_variant', header: { label: 'File Type', sort: 'uploads.gross_type' }, cell: typeVariantCell, enabled: true },
    {key: 'icon', header: {label: '', sort: null }, cell: iconCell, enabled: false },
    {key: 'name', header: { label: 'Title', sort: 'mindfile_items.name' }, cell: nameCell, enabled: true },
    {key: 'description', header: { label: 'Post', sort: 'mindfile_items.description' }, cell: descriptionCell, enabled: true },
    {key: 'date', header: { label: 'Date', sort: 'mindfile_items.date' }, cell: dateCell, enabled: true },
    {key: 'location', header: [
      { label: 'Location', sort: 'locations.country', nulls: true },
      {label:'Latitude', shortLabel: 'Lat', sort: 'locations.latitude', nulls: true },
      {label:'Longitude', shortLabel: 'Lng', sort: 'locations.longitude', nulls: true },
    ], cell: locationCell, enabled: true },
    {key: 'keywords', header: { label: 'Keywords', sort: 'keywords.text', asc: false, nulls: true }, cell: keywordsCell, enabled: true, action: (id) => this.addFilterSelectByName('Keywords', id)},
    {key: 'people', header: { label: 'People', sort: 'people.name', asc: false, nulls: true }, cell: peopleCell, enabled: true, action: (id) => this.addFilterSelectByName('People', id) },
    {key: 'emotion', header: { label: 'Emotion', sort: 'mindfile_items.emotion', nulls: true }, cell: emotionCell, enabled: true, action: (emotion) => this.addFilterSelectByName('Emotions', emotion) },
    {key: 'beme', header: { label: 'Beme', sort: 'mindfile_items.beme', nulls: true }, cell: bemeCell, enabled: true, action: (beme) => this.addFilterSelectByName('Bemes', beme) },
    {key: 'created', header: { label: 'Added', sort: 'mindfile_items.created_at', asc: false }, cell: createdCell, enabled: true },
    {key: 'updated', header: { label: 'Modified', sort: 'mindfile_items.updated_at', asc: false }, cell: updatedCell, enabled: true },
    {key: 'size', header: { label: 'Size', sort: 'uploads.size', asc: false, nulls: true }, cell: sizeCell, enabled: false },
    {key: 'folderName', header: { label: 'Folder', sort: 'folders.name' }, cell: folderNameCell, enabled: true, action: true },
    {key: 'source', header: { label: 'Source', sort: 'uploads.source', nulls: true }, cell: sourceCell, enabled: false },
  ];

  defaultViewOpts = {
    rowsPerPage: 12,
    orders: [{f: 'mindfile_items.updated_at', d: false, n: true}],
    viewMode: 'Stream',
    iconSize: 'Medium',
    visibleColumns: Object.assign({}, ...this.columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden})))
  };

  defaultFilters = (filters) => [
    { key: "status", selectedItems: [], },
    { key: "keywords", selectedItems: [], },
    { key: "people", selectedItems: [], },
    { key: "folders", selectedItems: [], },
    { key: "emotions", selectedItems: [], },
    { key: "bemes", selectedItems: [], },
    { key: "item_data_types", selectedItems: ['JournalPost'], },
    { key: "upload_types", selectedItems: [], },
    { key: "sources", selectedItems: [], },
    { key: "survey_names", selectedItems: [], },
    { key: "survey_complete", selectedItems: [], },
  ];

  state = {
    pageKey: "/explore/journal",
    title: "Mindfile Journal",
    loading: true,
    viewOptsLoaded: false,
    controller: {
      page: 1,
      rowsPerPage: this.defaultViewOpts.rowsPerPage,
      orders: this.defaultViewOpts.orders,
      search: null,
    },
    mapBounds: null,
    items: [],
    filter_count: 0,
    folderList: [],
    filterSelections: this.defaultFilters(),
    selectedIds: [],
    tableView: {
      addButtons: ['JournalPost'],
      viewMode: this.defaultViewOpts.viewMode,
      viewModeOptions: ['List', 'Icon', 'Stream'],
      iconSize: this.defaultViewOpts.iconSize,
      iconSizeOptions: ['Small', 'Medium', 'Large'],
      filtersOpen: false,
      columnsOpen: false,
      visibleColumns: this.defaultViewOpts.visibleColumns
    }
  };

  filters = this.filterDefinitions.map((filter, index) => ({
    ...filter, index: index, handleSelect: this.handleFilterSelect.bind(this, index), addFilterSelect: this.addFilterSelect.bind(this, index)
  }))

  handleFilterSelect(index, selections){
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: selections};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelect(index, optionId){
    let newFilters = [...this.state.filterSelections];
    let newSelection = [...newFilters[index].selectedItems];
    if(newSelection.indexOf(optionId) === -1){
      newSelection.push(optionId);
      newFilters[index] = {...(newFilters[index]), selectedItems: newSelection};
    }
    this.setState({tableView: {...this.state.tableView, filtersOpen: true}, filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelectByName(filterName, optionId){
    let filter = this.filters.find(x => x.label === filterName);
    if(filter){
      filter.addFilterSelect(optionId);
    }
  }

  componentDidMount() {
    this.props.getFolderList(this.props.mindfile.id);
    this.props.getFilterValues(this.props.mindfile.id);
    this.props.setSelectedItems({});
  }

  fetchItems(fetchLocations=false) {
    if(!this.props.mindfile.id) return;
    this.setState({loading: true});
    let fetchFilters =  Object.fromEntries(this.filters.map((f,index) => f.enabled ? [f.key, this.state.filterSelections[index].selectedItems] : null).filter(item => !!item));
    this.props.getMindfileItems(this.state.pageKey, this.props.mindfile.id, this.state.controller, fetchFilters, this.state.mapBounds, () => {
      if(this.props.mindfileFilterValues.updated) {
        this.props.getFilterValues(this.props.mindfile.id, this.props.mindfileFilterValues.updated);
      }
      this.setState({loading: false});
    });
    if(fetchLocations){
      this.props.getMindfileItemLocations(this.props.mindfile.id, this.state.controller, fetchFilters);
    }
  }

  render() {
    return (
      <>
        <ItemsPage
          title={this.state.title}
          displayCurrentMindfile={true}
          mindfileId={this.props.mindfile.id}
          itemList={this.props.itemsKey !== this.state.pageKey ? [] : this.props.items || []}
          itemCount={this.props.itemsKey !== this.state.pageKey ? 0 : this.props.filter_count}
          fetchItems={this.fetchItems.bind(this)}
          folderList={this.props.folderList}
          addFolder={this.props.addFolder}
          removeItems={this.props.removeItems.bind(this)}
          moveItems={this.props.moveItems.bind(this)}
          getMindfileItem={this.props.getMindfileItem.bind(this)}
          getMindfileItemsDetails={this.props.getMindfileItemsDetails.bind(this)}
          updateItemViewCount={this.props.updateItemViewCount.bind(this)}
          columns={this.columns}
          filters={this.filters}
          filterSelections={this.state.filterSelections}
          clearFilterSelections={() => this.setState({filterSelections: this.defaultFilters()})}
          addFilterSelectByName={this.addFilterSelectByName.bind(this)}
          mindfileFilterValues={this.props.mindfileFilterValues}
          selectedIds={this.state.selectedIds}
          setSelectedIds={(ids) => this.setState({selectedIds: ids})}
          selectedItems={this.props.selectedItems}
          setSelectedItems={this.props.setSelectedItems.bind(this)}
          controller={this.state.controller}
          setController={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevStateFunc(prevState, props)}})
            })
          }}
          getMindfileItemLocations={this.props.getMindfileItemLocations.bind(this)}
          mapBounds={this.state.mapBounds}
          setMapBounds={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
            })
          }}
          loading={this.state.loading}
          setLoading={(isLoading) => this.setState({loading: isLoading})}
          viewOptsLoaded={this.state.viewOptsLoaded}
          bindViewOptions={
            <BindViewOptions
              pageKey={this.state.pageKey}
              parentState={this.state}
              parentProps={this.props}
              setParentState={this.setState.bind(this)}
              defaultViewOpts={this.defaultViewOpts}
              loaded={this.state.viewOptsLoaded}
              setLoaded={loaded => this.setState({viewOptsLoaded: loaded})}
            />
          }
          addButtons={this.state.tableView.addButtons}
          viewMode={this.state.tableView.viewMode}
          setViewMode={(e) => this.setState({tableView: {...this.state.tableView, viewMode: e.target.value}})}
          viewModeOptions={this.state.tableView.viewModeOptions}
          iconSize={this.state.tableView.iconSize}
          setIconSize={(e) => this.setState({tableView: {...this.state.tableView, iconSize: e.target.value}})}
          iconSizeOptions={this.state.tableView.iconSizeOptions}
          filtersOpen={this.state.tableView.filtersOpen}
          setFiltersOpen={(open) => this.setState({tableView: {...this.state.tableView, filtersOpen: open}})}
          columnsOpen={this.state.tableView.columnsOpen}
          setColumnsOpen={(open) => this.setState({tableView: {...this.state.tableView, columnsOpen: open}})}
          visibleColumns={this.state.tableView.visibleColumns}
          setVisibleColumns={(columns) => this.setState({tableView: {...this.state.tableView, visibleColumns: columns}})}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    itemsKey: state.mindfile_items?.pageKey,
    items: state.mindfile_items?.items || [],
    filter_count: state.mindfile_items?.filter_count || 0,
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
    folderList: state.folderList,
    mindfileFilterValues: state.mindfileFilterValues,
    selectedItems: state.selectedItems,
  };
}

const mapDispatchToProps = {
  getFolderList,
  getMindfileItems,
  getMindfileItemsDetails,
  getMindfileItemLocations,
  addFolder,
  removeItems,
  moveItems,
  getMindfileItem,
  getFilterValues,
  setSelectedItems,
  updateItemViewCount
};

export default connect(mapStateToProps, mapDispatchToProps)(JournalExplorer);
